import React from "react";
import { DangerIcon } from "./icons";
import { MotionModal, ModalCloseButton } from "./motion";

// Red-topped warning popup (checkout, quotation): "Please input all required fields…".
const AlertModal = ({
  text = "Please input all required fields (highlighted  in red)",
  handleClose,
  show,
}) => {
  return (
    <MotionModal
      show={show}
      onClose={handleClose}
      maxWidthClassName="tw:max-w-[500px] tw:lg:max-w-[800px]"
      panelClassName="border-top-danger"
    >
      <div className="text-end me-4 mt-3 d-flex justify-content-end">
        <ModalCloseButton isInline onClick={handleClose} />
      </div>
      <div className="modal-body my-1 text-center" style={{ color: "#ED553B" }}>
        <h5 className="mb-4">
          <span className="me-2">
            <DangerIcon />
          </span>
          {text}
        </h5>
      </div>
    </MotionModal>
  );
};

export default AlertModal;
